import React, { useEffect } from 'react'

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared'

import { Confirm } from 'components/ui/modal'
import { StatusGuard } from 'components/ui/status-guard'

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions'
import { GettyStore } from 'domains/org/getty/store'

import { pick } from 'helpers/core'
import { Status } from 'helpers/status'

import { VisitorInfoPage } from 'generated/mos/org/getty/visitorinfo'
import { DeleteVisitorInfoPageRequest }  from 'generated/mos/org/getty/visitorinfomanagement'

import { visitorInfoSchema } from '../../../schemas/visitorInfo'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteVisitorInfoPageRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'visitorInfoDelete'>;

type DirectProps = {
  readonly page: VisitorInfoPage.Entity;
  readonly onCancel: () => void;
  readonly onComplete? : () => void;
}

type Props = ActionProps & ConnectedProps & DirectProps;

const VisitorInfoDeleteView = (props: Props) => {
  const {
    gettyDeleteVisitorInfoPageRequest,
    toastNotification,
    visitorInfoDelete,
    onCancel,
    onComplete,
    page,
  } = props

  const message = <>
    <p>Are you sure you want to permanently delete</p>
    <p>"{visitorInfoSchema.listTitle.read(page.listTitle)}"?</p>
  </>

  const onConfirmDelete = () => {
    page.ref && gettyDeleteVisitorInfoPageRequest({
      ...DeleteVisitorInfoPageRequest.defaults,
      visitorInfoPageRef: page.ref,
    })
    onCancel()
    onComplete && onComplete()
  }

  useEffect(() => {
    visitorInfoDelete.status === Status.Failed &&
      toastNotification({
        type: 'error',
        text: 'Could not delete visitor info page',
      });
  }, [visitorInfoDelete.status, toastNotification])

  return (
    <StatusGuard status={visitorInfoDelete}>
      <Confirm
        title="Delete Visitor Info Page?"
        onClose={onCancel}
        message={message}
        confirmLabel="Delete"
        onConfirm={onConfirmDelete}
        danger
      />
    </StatusGuard>
  );
};

export const VisitorInfoDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'visitorInfoDelete'),
  {
    ...pick(actionCreators, 'gettyDeleteVisitorInfoPageRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(VisitorInfoDeleteView)
